// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"cfd253bd","23":"cfe67d1e","49":"fbaa34d7","87":"3b7bbf0e","163":"65aa1d53","251":"1a4ffae7","460":"e92cc32f","693":"095fbacb","767":"a409cf32","871":"b77534d7","904":"6595778d"}[chunkId] + ".chunk.js";
};